import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable }   from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { AppService } from '../shared/service/AppService.class';
import { Lead, Summary } from './model/model.lead';

@Injectable()
export class LeadService extends AppService<Lead>{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "leads";
  }
  //search insurance in lead
  Searchinsurance(sdata):Observable<any>
  {
    console.log("Searchinsurance lead service",sdata);
    let tmp = this.appmod;
    this.appmod = 'custom/insuranceSearch';
    let result = this.saveService(sdata);
    this.appmod = tmp;
    return result;
  }

  // search insurance Result in leads
  public getSearchInsuranceResult(type): Observable<Lead[]> {
    console.log("getSearchInsuranceResult",type);    
    let tmp = this.appmod;
    this.appmod = "custom/leadSearchInsurance";
    let result = super.getService(type);
    this.appmod = tmp;
    return result;
  }

  public getTemplate(): Observable<Lead[]> {
    let tmp = this.appmod;
    this.appmod = "custom/gettemplate";
    let result = super.getService();
    this.appmod = tmp;
    return result;
  }
  public gettotallead(id: any): Observable<any> {
    console.log("gettotallead");
    
    let tmp = this.appmod;
    this.appmod = 'custom/totallead/';
    let result = super.getService(id);
    this.appmod = tmp;
    return result;
  }

  public GetAgentLead(campid: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/getagentlead';
    let result = super.getService(campid);
    this.appmod = tmp;
    return result;
  }
  public saveHeaderMapping(data: any): Observable<any> {
    console.log("header service data",data);    
    let tmp = this.appmod;
    this.appmod = 'custom/saveheadermapping';
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
  }

  public saveQuickUpload(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/quickuploadsleads';
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
  }

  public saveleadtype(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/saveleadtype';
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
  }

  public saveSingleLead(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/saveSinghLead';
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
  }

  public getleadlistt( filter:any): Observable<Lead[]> {
    // console.log("getleadlistType",type);
    console.log("getleadlistFilterrrr",filter);
    let tmp = this.appmod;
    this.appmod = 'custom/leadslistt';
    let result = super.getService( filter);
    this.appmod = tmp;
    return result;
  }

  public getleadlist(filter:any): Observable<Lead[]> {
    let tmp = this.appmod;
    this.appmod = 'custom/leadslist';
    let result = super.getService( filter);
    this.appmod = tmp;
    return result;
  }

  public downloadLeads(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/downloadleads';
    let result = super.getDownload(data, 'downloadleads');
    this.appmod = tmp;
    return result;
  }


  public getleadField(data: any): Observable<any> {
    return super.getService('leadfield', data.id);
  }

  public getLeadDetail(data: any): Observable<any> {
    return super.getService('leadDeatil', data.id);
  }

  public updateLead(data: any, key:any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/updateLead';
    let result = super.updateService(data, key);
    this.appmod = tmp;
    return result;
  }

  public updateLeadScript(data: any, key: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/updateLeadscript';
    let result = super.updateService(data, key);
    this.appmod = tmp;
    return result;
  }

  public updateLeadStatus(data: any, key: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/updateLeadstatus';
    let result = super.updateService(data, key);
    this.appmod = tmp;
    return result;
  }

  public getLeadFilter(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/getLeadFilter';
    let result = super.getService(data);
    this.appmod = tmp;
    return result;
  }

  public deleteLeads(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/deleteLeads';
    let result = super.deleteService(data);
    this.appmod = tmp;
    return result;
  }

  public getDuplicateLeads(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/duplicateleads';
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
  }


  public DeleteDuplicateLeads(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/deleteduplicateleads';
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
  }

  // @ac lead script
  public acUpdateLeadScript(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/acUpdateLeadscript';
    let result = super.updateService(data);
    this.appmod = tmp;
    return result;
  }

  // @ac lead status
  public acUpdateLeadStatus(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/acUpdateLeadstatus';
    let result = super.updateService(data);
    this.appmod = tmp;
    return result;
  }

  // @ac assign agents
  public acUpdateAgent(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/acUpdateAgent';
    let result = super.updateService(data);
    this.appmod = tmp;
    return result;
  }

  // @ac lead's dialers
  public acUpdateDialers(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/acUpdateDialers';
    let result = super.updateService(data);
    this.appmod = tmp;
    return result;
  }

  // @ac delete leads
  public deleteSLeads(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/deleteSLeads';
    let result = super.deleteService(data);
    this.appmod = tmp;
    return result;
  }

  // @custom phone scripts
  getScripts(): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/getphonescript";
    let data = this.getService();
    this.appmod = tmp;
    return data;
  }

  // @custom leads columns
  getLeadsColumns(type: string): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/get_leads_comumns";
    let data = this.getService(type);
    this.appmod = tmp;
    return data;
  }

  // @load crm labels
  getCRMLabels(type: string): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/crmlabel";
    let data = this.getService(type);
    this.appmod = tmp;
    return data;
  }

  // @load selected lead's data
  getFilteredLedas(sdata: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/get_filtered_leads";
    let data = this.saveService(sdata);
    this.appmod = tmp;
    return data;
  }

  // @custom lead's fields
  GetLeadFields(type: string): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/get_lead_fields";
    let data = this.getService(type);
    this.appmod = tmp;
    return data;
  }

  // @custom lead's fields
  GetLeadHeaders(type: string): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/get_lead_headers";
    let data = this.getService(type);
    this.appmod = tmp;
    return data;
  }


  //get automation service
  getAutomation(sdata:any): Observable<any> {
    console.log("getAurtomation lead service>>",sdata );    
    let tmp = this.appmod;
    this.appmod = "custom/getautomation"
    let data = this.getService(sdata);
    this.appmod = tmp;
    return data;
  }

  // @custom lead's status
  GetLeadStatus(type: string): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/get_lead_status";
    let data = this.getService(type);
    this.appmod = tmp;
    return data;
  }

  // @custom phone script
  GetPhoneScript(type: string): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/get_phone_script";
    let data = this.getService(type);
    this.appmod = tmp;
    return data;
  }

  // @custom lead's data
  GetSingleLeadData(type: string): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/get_single_lead_data";
    let data = this.getService(type);
    this.appmod = tmp;
    return data;
  }

  getcallerid(type: string,filter:any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "campaign";
    let data = this.getService(type,filter);
    this.appmod = tmp;
    return data;
  }
  
  //get helthInsurance data
  getHealthData(sdata:any):Observable<any>
  {
    console.log("getHealthData::",sdata);
    let tmp=this.appmod
    this.appmod="custom/gethealthData"
    let data=this.getService(sdata)
    this.appmod=tmp;
    return data
  }
  
  gethealthinfo(type:any):Observable<any>
  {
    let tmp=this.appmod
    this.appmod="custom/healthinfo"
    let data=this.getService(type)
    this.appmod=tmp;
    return data
  }

  // addzap(newItemmaster: any) {
  //   // return this.http.post(this.url, newItemmaster, this.httpOptions);
  //   let tmp = this.appmod;
  //   this.appmod = 'https://hooks.zapier.com/hooks/catch/9769843/o7afabr';
  //   let result = this.http.post(this.appmod, newItemmaster, this.httpOptions)
  //   this.appmod = tmp;
  //   return result;
  // }

  AutomationData(sdata:any): Observable<any> {
    console.log("getAutomationService");    
    let tmp = this.appmod;
    this.appmod = "custom/FetchAutomationData";
    let result = super.getService(sdata);
    this.appmod = tmp;
    return result;
  }

  // sendAuto
  sendAuto(sdata:any): Observable<any> {
    console.log("SendAutoID's::",sdata);    
    let tmp = this.appmod;
    this.appmod = "custom/sendautodata";
    let result = super.saveService(sdata);
    this.appmod = tmp;
    return result;
  }

  // removeAutomation
  removeAutomation(sdata:any): Observable<any> {
    console.log("removeAutomation::",sdata);    
    let tmp = this.appmod;
    this.appmod = "custom/removeautomation";
    let result = super.saveService(sdata);
    this.appmod = tmp;
    return result;
  }

  //get lead All data
  public getSingleContact(type:any):Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/leadAllData";   
    let data = this.getService(type);
    this.appmod=tmp;
    return data;
  }
  smstemplate(type:any){
    let tmp = this.appmod;
    this.appmod="custom/getdialerSmsTemplate";   
    let auth = this.getService(type);
    this.appmod=tmp;
    return auth;  
  }
  getemailtempalte(type:any) {
    let tmp = this.appmod;
    this.appmod="custom/getdialerEmailTemplate";   
    let auth = this.getService(type);
    this.appmod=tmp;
    return auth; 
  }
  getEvents(type:any) {
    let tmp = this.appmod;
    this.appmod="custom/events";   
    let auth = this.getService(type);
    this.appmod=tmp;
    return auth; 
  }

  getAllRecentHistory(id:any){
    let tmp = this.appmod;
    this.appmod="custom/allRecentData";   
    let auth = this.getService(id);
    this.appmod=tmp;
    return auth;
  }
  getcallReport(lead:any){
    let tmp = this.appmod;
    this.appmod="custom/rptCallHistory";   
    let auth = this.getReport(lead);
    this.appmod=tmp;
    return auth;
  }
  getsmsReport(lead:any){
    let tmp = this.appmod;
    this.appmod="custom/eptSMS";   
    let auth = this.getReport(lead);
    this.appmod=tmp;
    return auth;
  }

  getemailReport(lead:any){
    let tmp = this.appmod;
    this.appmod="custom/rptEmails";   
    let auth = this.getReport(lead);
    this.appmod=tmp;
    return auth;
  }

  getapptReport(lead:any){
    let tmp = this.appmod;
    this.appmod="custom/rptAPPTSchedule";   
    let auth = this.getReport(lead);
    this.appmod=tmp;
    return auth;
  }

  getdispoReport(lead:any){
    let tmp = this.appmod;
    this.appmod="custom/reportDspHistory";   
    let auth = this.getReport(lead);
    this.appmod=tmp;
    return auth;
  }
  getobjectionReport(lead:any){
    let tmp = this.appmod;
    this.appmod="custom/reportObjHistory";   
    let auth = this.getReport(lead);
    this.appmod=tmp;
    return auth;
  }
  public LogsRecord(): Observable<any> {
    // return this.http.get('./assets/logs.json');
    let tmp = this.appmod;
    this.appmod = "custom/log_record";
    let result = super.getService();
    this.appmod = tmp;
    return (result);
  }

  public saveEMService(sdata:any):Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/saveemaillead";   
    let data = this.saveService(sdata);
    this.appmod=tmp;
    return data;   
  }
  CallErID(type:string):Observable<any>
  {
    console.log("type",type);
    // console.log("filter",filter);
    let temp = this.appmod;
    this.appmod = 'custom/GetcallerID';
    let result = this.getService(type);
    this.appmod = temp;
    return result;
  }
  public saveSMS(sdata:any):Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/sendsms";   
    let data = this.saveService(sdata);
    this.appmod=tmp;
    return data;   
  }

  public update_Lead(sdata:any):Observable<any>{
    let tmp = this.appmod;
    this.appmod="custom/saveLeadData";   
    let data = this.saveService(sdata);
    this.appmod=tmp;
    return data;   
  }
  public AutomationUpdate(data: any): Observable<any> {
    console.log("PPPP", data)
    let tmp = this.appmod;
    this.appmod = 'custom/updateautomation';
    let result = super.updateService(data);
    this.appmod = tmp;
    return result;
  }
}


@Injectable()
export class SummaryService extends AppService<Summary>{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "leads";
  }

  public ReAssignLeads(data: any): Observable<any> {
    console.log("ReAssignLeads service:",data);
    
    let tmp = this.appmod;
    this.appmod = 'custom/reassignleads';
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
  }

  public gettotallead(): Observable<any> {
    console.log("gettotallead");

    let tmp = this.appmod;
    this.appmod = 'custom/totallead/';
    let result = super.getService();
    this.appmod = tmp;
    return result;
  }

  public updateAssignLead(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/updateassignLead';
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
  }

  public GetLeads(): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/getfreelead/';
    let result = super.getService();
    this.appmod = tmp;
    return result;
  }


  public GetAgentLead(): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/getagentlead';
    let result = super.getService();
    this.appmod = tmp;
    return result;
  }

  public DeleteAllLeads(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/deleteallleads';
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
  }

  public getStateOption(): Observable<any[]> {
    let tmp = this.appmod;
    this.appmod = "globalfilter";
    let state = this.getOption("statelist");
    this.appmod = tmp;
    return state;
  }

  public getScriptOption(type: string, filter: any): Observable<any[]> {
    let tmp = this.appmod;
    this.appmod = "globalfilter";
    let srcipt = this.getService(type, filter);
    this.appmod = tmp;
    return srcipt;
  }

  public getLeadStageOption(type: string, filter: any): Observable<any[]> {
    let tmp = this.appmod;
    this.appmod = "manageworkflow";
    let srcipt = this.getService(type, filter);
    this.appmod = tmp;
    return srcipt;
  }

  public getDispositionOption(type: string, filter: any): Observable<any[]> {
    let tmp = this.appmod;
    this.appmod = "customdisposition";
    let srcipt = this.getService(type, filter);
    this.appmod = tmp;
    return srcipt;
  }

  public getCountyOption(data: any) {
    console.log("Get Country Called" + data);
    return this.getOptionParams("custom/country", data);
  }

  public getCityOption(data: any) {
    console.log("Get City Called" + JSON.stringify(data));
    return this.getOptionParams("custom/city", JSON.stringify(data));
  }

  public getZipOption(data: any) {
    console.log("Get Zip Called" + JSON.stringify(data));
    return this.getOptionParams("custom/zip", JSON.stringify(data));
  }

  public getDeletedLeads(): Observable<any[]> {
    let tmp = this.appmod;
    this.appmod = "custom/getdeletedlead";
    let sdata = this.getService();
    this.appmod = tmp;
    return sdata;
  }

  public RestoreINLeads(sdata: any): Observable<any[]> {
    let tmp = this.appmod;
    this.appmod = "custom/restoreleads";
    let rdata = this.saveService(sdata);
    this.appmod = tmp;
    return rdata;
  }

  public SerachLeads(type: string): Observable<any[]> {
    let tmp = this.appmod;
    this.appmod = "custom/searchleads";
    let sdata = this.getService(type);
    this.appmod = tmp;
    return sdata;
  }

  // @custom phone scripts
  getScripts(type: string): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/getphonescript";
    let data = this.getService(type);
    this.appmod = tmp;
    return data;
  }

  // @custom CRM workflow
  getCRMWorkflow(type: string): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/get_crm_workflow";
    let data = this.getService(type);
    this.appmod = tmp;
    return data;
  }

  // @custom dispositions
  getCustomDispos(type: string): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/get_custom_dispos";
    let data = this.getService(type);
    this.appmod = tmp;
    return data;
  }

  // @custom lead filter
  public AssignLeadFilter(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'custom/assignLeadFilter';
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
  }

  // @custom dialer lead counts
  GetDialerLeads(type: string): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/get_dialer_leads";
    let data = this.getService(type);
    this.appmod = tmp;
    return data;
  }

  // @get custom dispositions
  GetCustomDisposition(type: string): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/get_custom_disposition";
    let data = this.getService(type);
    this.appmod = tmp;
    return data;
  }

  // @get CRM Workflows
  GetCrmWorkflows(type: string): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/get_crm_workflows";
    let data = this.getService(type);
    this.appmod = tmp;
    return data;
  }
 
  
}
